export function containsNonNumeric(value: string): boolean {
  return /[^\d]/.test(value);
}
